import React from "react";
import { useEffect } from "react";
import { downloads as HCPDownloads } from "./hcp/resources/resource-data";
import { MaintenanceNotice } from "../components";
import { useMaintenance } from "../hooks";

export default function Redirect() {
  const maintenance = useMaintenance();

  useEffect(() => {
    if (maintenance) {
      return;
    }

    const path = new URL(window.location).pathname;
    const pieces = path.split("/");

    var filtered = pieces.filter(function (el) {
      return el !== "";
    });

    const site = filtered[1];

    if (site === "hcp") {
      const resource = parseInt(filtered[2]);

      if (HCPDownloads[resource]) {
        setTimeout(() => {
          window.location = HCPDownloads[resource].link;
        }, 1000);
      } else {
        window.location = "/";
      }
    } else {
      window.location = "/";
    }

    return;
  }, [maintenance]);

  if (maintenance) {
    return <MaintenanceNotice title={maintenance.title} description={maintenance.description} />;
  }

  return <p></p>;
}
